// Single JS source for the per-condition affected-status axis + carrier-basis
// labels (FEATURE_CARRIER_STATUS_IN_CONDITION). The field enum lives in the
// Mongoose schema (backend/models/diagnoses-scehma.js); these are the UI labels
// — per the project decision that the Mongoose schema is the field source of
// truth and labels live in the component layer.

export const AFFECTED_STATUS = Object.freeze({
  unknown: 'unknown',
  unaffected: 'unaffected',
  carrier: 'carrier',
  affected: 'affected'
});

export const AFFECTED_STATUS_OPTIONS = [
  { label: 'Unknown', value: AFFECTED_STATUS.unknown },
  { label: 'Unaffected', value: AFFECTED_STATUS.unaffected },
  { label: 'Carrier', value: AFFECTED_STATUS.carrier },
  { label: 'Affected', value: AFFECTED_STATUS.affected }
];

// strictAcmgTier (src/util/variantPathogenicity.js) returns an exact canonical
// tier string; the schema carrierBasis.tested.classification enum is
// lower_snake and P/LP only (per the pedigree display rule). Compound
// classifications resolve to null there rather than being guessed into one of
// these two values, so they are deliberately not offered as a link target.
export const TIER_TO_CLASSIFICATION = Object.freeze({
  Pathogenic: 'pathogenic',
  'Likely Pathogenic': 'likely_pathogenic'
});

// Optional classification on the "reported" (external/clinical) carrier basis.
export const REPORTED_CLASSIFICATION_OPTIONS = [
  { label: 'Pathogenic', value: 'pathogenic' },
  { label: 'Likely pathogenic', value: 'likely_pathogenic' }
];
